import { render, staticRenderFns } from "./EmailDisplay.vue?vue&type=template&id=000c82c8"
import script from "./EmailDisplay.vue?vue&type=script&lang=js"
export * from "./EmailDisplay.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports